export default __webpack_public_path__ + "static/media/banner_placeholder.13f65949.png";